/* angular:styles/component:css;5deb6c9b34570b7d;/home/runner/work/app/app/src/app/components/coach/coach-launcher/coach-launcher.component.ts */
app-coach-launcher {
  display: contents;
}
.coach-preview {
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
  box-sizing: border-box;
  width: max-content;
  max-width: min(22rem, calc(100vw - 2rem));
  padding: 0.75rem 0.5rem 0.75rem 0.875rem;
  border-radius: var(--radius-xl, 0.75rem);
  background: var(--background-color, #fff);
  color: var(--text-color);
  border: 1px solid var(--border-color, #e2e8f0);
  box-shadow: var(--shadow-xl, 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1));
  font-family: var(--font-body, "Inter", system-ui, sans-serif);
  font-size: 0.875rem;
  line-height: 1.45;
}
body.dark .coach-preview {
  background: var(--surface-color, #242526);
  box-shadow: 0 24px 48px -12px rgb(0 0 0 / 0.7), 0 8px 16px -8px rgb(0 0 0 / 0.5);
}
.coach-preview-open {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0;
  border: none;
  border-radius: 0.375rem;
  background: none;
  color: inherit;
  font: inherit;
  text-align: start;
  cursor: pointer;
}
.coach-preview-head {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  min-width: 0;
  color: var(--text-secondary-color, #475569);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1rem;
}
.coach-preview-icon {
  flex: none;
  color: var(--accent-color, #4c17ca);
}
.coach-preview-label {
  flex: none;
}
.coach-preview-subject {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.coach-preview-text {
  overflow-wrap: anywhere;
}
.coach-preview-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
.coach-preview-open:focus-visible,
.coach-preview-close:focus-visible {
  outline: 2px solid var(--accent-color);
  outline-offset: 2px;
}
.coach-preview-close {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  border: none;
  border-radius: 0.375rem;
  background: none;
  color: var(--text-secondary-color, #475569);
  cursor: pointer;
}
.coach-preview-close:hover {
  background: var(--surface-hover, var(--surface-color));
  color: var(--text-color);
}
/*# sourceMappingURL=coach-launcher.component-CUSWB5RE.css.map */
